const colors = {
    brand: {
      50: '#fbeae7',
      100: '#f5cac5',
      200: '#eea8a0',
      300: '#e9887c',
      400: '#e36759',
      500: '#7b1b14', // Primary red
      600: '#6e1712',
      700: '#62120f',
      800: '#550d0c',
      900: '#490909',
    },
    black: '#000000',
    white: '#ffffff',
    gray: {
      50: '#f7fafc',
      100: '#edf2f7',
      200: '#e2e8f0',
      300: '#cbd5e0',
      400: '#a0aec0',
      500: '#718096',
      600: '#4a5568',
      700: '#2d3748',
      800: '#1a202c',
      900: '#171923',
    },
  }
  
  export default colors
  